import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import styles from './FeatureDetailHeader.module.scss';
import actions from './actions';
import { formatDate, getColor } from '../../../../lib/utils';
import { FEATURE_TYPES } from '../../../../lib/constants';
import WaypointIcon from '../../../../assets/svg/WaypointIcon';
import LineIcon from '../../../../assets/svg/LineIcon';
import AreaIcon from '../../../../assets/svg/AreaIcon';
import TracksIcon from '../../../../assets/svg/TracksIcon';

const FeatureDetailHeader = (props) => {
  const feature = props.feature;
  const type = props.feature.properties.ghType;

  const Icon = () => {
    if (type === FEATURE_TYPES.Point) {
      return (
        <WaypointIcon
          icon={props.feature.properties.icon}
          color={getColor(feature)}
          width={23}
          height={29}
        />
      );
    } else if (type === FEATURE_TYPES.Polyline) {
      return <LineIcon color={getColor(feature)} />;
    } else if (type === FEATURE_TYPES.Polygon) {
      return <AreaIcon color={getColor(feature)} />;
    } else if (type === FEATURE_TYPES.Tracks) {
      return <TracksIcon color={getColor(feature)} />;
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.icon}>
        <Icon />
      </div>
      <div className={styles.title}>
        <h1>{props.feature.title}</h1>
        <p className={styles.createdDate}>
          Created: { formatDate(props.feature.properties.createdAt) }
        </p>
      </div>
    </div>
  );
};

FeatureDetailHeader.propTypes = {
  feature: PropTypes.object
};

export default connect((model) => ({
  feature: model.features.selectedFeature
}), actions)(FeatureDetailHeader);